/**
 * Get the next item of an array
 * @param current - The current item
 * @param array - The array
 * @returns The next item or the first item if the current item is the last item
 */
export const getNext = <T>(current: T, array: T[]) => {
  const nextIndex = array.indexOf(current) + 1;
  return nextIndex < array.length ? array[nextIndex] : array[0];
};

/**
 * Get the previous item of an array
 * @param current - The current item
 * @param array - The array
 * @returns The previous item or the last item if the current item is the first item
 */
export const getPrevious = <T>(current: T, array: T[]) => {
  const previousIndex = array.indexOf(current) - 1;
  return previousIndex >= 0 ? array[previousIndex] : array[array.length - 1];
};

export const toArray = <T>(value: T[] | T | undefined): T[] => {
  if (value === undefined) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  return value ? [value] : [];
};
